var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable, makeObservable } from 'mobx';
import { runtime } from '../../../classes/runtime/Runtime';
import { Actor } from '../../../classes/actor/Actor';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { deserialize } from '../../../utils/serializr/serializr';
import { AssociationFly } from './modules/AssociationFly';
import { AssociationDrag } from './modules/AssociationDrag';
import { editable } from '../../../utils/mobx/decorators/editable';
import { AssociationUI } from './modules/AssociationUI';
import { toNumber } from '../../../utils/helper/lodash_replacements';
export class Association extends Actor {
    type = 'association';
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get question() {
        return this.parent;
    }
    get associationEdit() {
        return new runtime.solidPackages.Edit.classes.AssociationEdit(this);
    }
    get associationFly() {
        return new AssociationFly(this);
    }
    get associationDrag() {
        return new AssociationDrag(this);
    }
    get associationUI() {
        return new AssociationUI(this);
    }
    targetOptionNumber = 1;
    associatedOptionNumber;
    associatedDate;
    creationTime = new Date().getTime();
    associateLegacyId;
    numberOfFailedAttempts = 0;
    dateOfLatestFailedAttempt;
    failedOptionNumber;
    get place() {
        return `field${this.targetOptionNumber}_${this.creationTime}`;
    }
    set place(place) {
        const pieces = place.split('_');
        this.creationTime = Math.round(toNumber(pieces[1]));
        const pieces2 = pieces[0].split('field');
        this.targetOptionNumber = toNumber(pieces2[1]);
    }
    get isCurrentAssociation() {
        return this.question.currentAssociation === this;
    }
    get isAssociationComplete() {
        return !!this.associatedOptionNumber;
    }
    get isAssociationFinished() {
        if (!this.isAssociationComplete)
            return false;
        return this.isFeedbackTimeOver;
    }
    get isCorrectlyAssociated() {
        return this.targetOptionNumber === this.associatedOptionNumber;
    }
    get isWronglyAssociated() {
        return !!this.associatedOptionNumber && this.targetOptionNumber !== this.associatedOptionNumber;
    }
    get passedFeedbackTime() {
        if (!this.associatedDate)
            return 1;
        return this.question.context.app.appClock.clock_1000.tickingTime - this.associatedDate.getTime();
    }
    get remainingFeedbackTime() {
        return this.associationFeedbackTime - this.passedFeedbackTime;
    }
    get remainingFeedbackTimeInSeconds() {
        return Math.ceil(this.remainingFeedbackTime / 1000);
    }
    get associationFeedbackTime() {
        return 1000;
    }
    get feedbackText() {
        return '';
    }
    get isFeedbackTimeOver() {
        return this.remainingFeedbackTimeInSeconds <= 0;
    }
    get targetOption() {
        if (!this.question)
            return undefined;
        return this.question.options[this.targetOptionNumber - 1];
    }
    static fromSerialized(ser = {}) {
        return deserialize(Association, ser);
    }
    static get serializeInfo() {
        return {
            extends: Actor.serializeInfo,
            props: {
                targetOptionNumber: true,
                place: true,
                associateLegacyId: true,
            },
        };
    }
    static get stripInfo() {
        return {
            extends: Actor.stripInfo,
            props: {
                targetOptionNumber: true,
            },
        };
    }
}
__decorate([
    memoize
], Association.prototype, "associationEdit", null);
__decorate([
    memoize
], Association.prototype, "associationFly", null);
__decorate([
    memoize
], Association.prototype, "associationDrag", null);
__decorate([
    memoize
], Association.prototype, "associationUI", null);
__decorate([
    editable()
], Association.prototype, "targetOptionNumber", void 0);
__decorate([
    observable
], Association.prototype, "associatedOptionNumber", void 0);
__decorate([
    observable
], Association.prototype, "associatedDate", void 0);
__decorate([
    observable
], Association.prototype, "creationTime", void 0);
__decorate([
    observable
], Association.prototype, "associateLegacyId", void 0);
__decorate([
    observable
], Association.prototype, "numberOfFailedAttempts", void 0);
__decorate([
    observable
], Association.prototype, "dateOfLatestFailedAttempt", void 0);
__decorate([
    observable
], Association.prototype, "failedOptionNumber", void 0);
__decorate([
    computed
], Association.prototype, "place", null);
__decorate([
    computed
], Association.prototype, "isAssociationFinished", null);
__decorate([
    computed
], Association.prototype, "passedFeedbackTime", null);
__decorate([
    computed
], Association.prototype, "feedbackText", null);
__decorate([
    memoize
], Association, "serializeInfo", null);
__decorate([
    memoize
], Association, "stripInfo", null);
